export type ColorIdTokenType =
  | 'slate'
  | 'blue'
  | 'aqua'
  | 'ice'
  | 'sky'
  | 'skyLight'
  | 'stone'
  | 'gray'
  | 'tangerine'
  | 'tangerineLight'
  | 'coral'
  | 'coralLight'
  | 'violet'
  | 'violetLight'
  | 'white'
  | 'transparent'
  | 'LightGray'
  | 'DarkGray'

export type ColorTokenType = {
  [key in ColorIdTokenType]: IColorTokenProps
}

export interface IColorTokenProps {
  label: string
  hex: string | null
  rgba: IColorTokenRGBAProps
}

export interface IColorTokenRGBAProps {
  r: string
  g: string
  b: string
  a: string
}

export const COLOR_TOKENS: ColorTokenType = {
  slate: {
    label: 'Slate',
    hex: '#081d34',
    rgba: {
      r: '13',
      g: '29',
      b: '50',
      a: '1',
    },
  },
  blue: {
    label: 'Blue',
    hex: '#0057ff',
    rgba: {
      r: '35',
      g: '86',
      b: '246',
      a: '1',
    },
  },
  aqua: {
    label: 'Aqua',
    hex: '#47c7f0',
    rgba: {
      r: '109',
      g: '196',
      b: '236',
      a: '1',
    },
  },
  ice: {
    label: 'Ice',
    hex: '#bff5f8',
    rgba: {
      r: '202',
      g: '244',
      b: '247',
      a: '1',
    },
  },
  sky: {
    label: 'Sky',
    hex: '#c4e0fd',
    rgba: {
      r: '202',
      g: '223',
      b: '250',
      a: '1',
    },
  },
  skyLight: {
    label: 'Sky light',
    hex: '#e4eefa',
    rgba: {
      r: '228',
      g: '238',
      b: '250',
      a: '1',
    },
  },
  stone: {
    label: 'Stone',
    hex: '#f1f1f1',
    rgba: {
      r: '202',
      g: '223',
      b: '250',
      a: '1',
    },
  },
  gray: {
    label: 'Gray',
    hex: '#e6e6e6',
    rgba: {
      r: '230',
      g: '230',
      b: '230',
      a: '1',
    },
  },
  tangerine: {
    label: 'Tangerine',
    hex: '#fea143',
    rgba: {
      r: '252',
      g: '160',
      b: '77',
      a: '1',
    },
  },
  tangerineLight: {
    label: 'Tangerine light',
    hex: '#fcc692',
    rgba: {
      r: '252',
      g: '198',
      b: '146',
      a: '1',
    },
  },
  coral: {
    label: 'Coral',
    hex: '#ff645f',
    rgba: {
      r: '252',
      g: '101',
      b: '99',
      a: '1',
    },
  },
  coralLight: {
    label: 'Coral light',
    hex: '#ffa19f',
    rgba: {
      r: '255',
      g: '161',
      b: '159',
      a: '1',
    },
  },
  violet: {
    label: 'Violet',
    hex: '#4f66c2',
    rgba: {
      r: '80',
      g: '104',
      b: '191',
      a: '1',
    },
  },
  violetLight: {
    label: 'Violet light',
    hex: '#96a4d8',
    rgba: {
      r: '150',
      g: '164',
      b: '216',
      a: '1',
    },
  },
  white: {
    label: 'White',
    hex: '#ffffff',
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  transparent: {
    label: 'Transparent',
    hex: '#ffffff00',
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '0',
    },
  },
  LightGray: {
    label: 'Light Gray',
    hex: '#ffffff80',
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '0.5',
    },
  },
  DarkGray: {
    label: 'Dark Gray',
    hex: '#00000080',
    rgba: {
      r: '0',
      g: '0',
      b: '0',
      a: '0.5',
    },
  },
}
